'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reports = require('./reports.html');

var _reports2 = _interopRequireDefault(_reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _reports2.default,
  bindings: {
    reportTypes: '<',
    chartConfig: '<',
    flex: '<',
    layout: '<'
  },
  controller: function () {
    function ReportsComponent($mdDialog, $scope, $state, ReportService) {
      'ngInject';

      _classCallCheck(this, ReportsComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        ReportService: ReportService
      });
    }

    _createClass(ReportsComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.setSelectedReportFromState();
      }
    }, {
      key: 'setSelectedReportFromState',
      value: function setSelectedReportFromState() {
        var _this = this;

        var reportType = this.reportTypes.filter(function (f) {
          return f.state === _this.$state.current.name;
        });
        if (reportType && reportType.length) {
          this.selectedReport = reportType[0];
        }
      }
    }, {
      key: 'onReportChanged',
      value: function onReportChanged(reportType) {
        if (reportType) {
          this.$state.go(reportType.state);
        }
      }
    }]);

    return ReportsComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/reports/reports.component.js